module.exports = __webpack_public_path__ + "static/media/karan.a8ea629f.jpg";